import { render, staticRenderFns } from "./giftcards-items-list.vue?vue&type=template&id=18ba1a78&scoped=true&"
import script from "./giftcards-items-list.vue?vue&type=script&lang=js&"
export * from "./giftcards-items-list.vue?vue&type=script&lang=js&"
import style0 from "./giftcards-items-list.vue?vue&type=style&index=0&id=18ba1a78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba1a78",
  null
  
)

export default component.exports